// get data from local storage
// Helper function to get data from localStorage and parse it as JSON
export const getDataFromStorageHelper = (key) => {
  if (typeof window !== "undefined") {
    const storedData = localStorage.getItem(key);
    return storedData !== null ? JSON.parse(storedData) : null;
  }
  return null;
};

export const deleteDataFromStorageHelper = (key) => {
  if (typeof window !== "undefined") {
    const storedData = localStorage.removeItem(key);
    return null;
  }
  return null;
};

export const setDataInStorageHelper = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};
// get show start time and end time

export const getShowTime = (date) => {
  if (typeof window !== "undefined") {
    const time = new Date(date * 1000)
      .toLocaleTimeString()
      .replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
    return time;
  }
};

export const getDOMelement = (id) => {
  if (typeof window !== "undefined") {
    const getElement = document.getElementById(id);
    return getElement;
  }
};

// store data in session storge
export const storeDataInSession = (key, data) => {
  sessionStorage.setItem(key, data);
};
// get data from session storge
export const getDataFromSession = (key) => {
  if (typeof window !== "undefined") {
    const item = sessionStorage.getItem(key);
    return item;
  }
};
